export const COLUMNS = [
  {
    Header: "Full Name",
    Footer: "firstName",
    accessor: row => {
      if (row.paymentInit?.Employee) {
        return `${row.paymentInit.Employee.firstName || ''} ${row.paymentInit.Employee.lastName || ''}`.trim();
      }
      return row.fullName || 'N/A';
    },
  },
  {
    Header: "Passport No",
    Footer: "Passport",
    accessor: row => row.passportNumber || row.paymentInit?.Employee?.Passports?.[0]?.passportNo || 'N/A',
  },
  {
    Header: "Year",
    Footer: "",
    accessor: row => row.paymentInit?.year || row.year || 'N/A',
  },
  {
    Header: "Total Amount",
    Footer: "",
    accessor: row => {
      const amount = row.paymentInit?.amount ?? row.initialAmount;
      return amount ? parseFloat(amount).toLocaleString() : '0';
    },
  },
  {
    Header: "Payment Amount",
    Footer: "",
    accessor: row => {
      const paymentAmount = row.totalPayments ?? row.totalPaid ?? 0;
      return paymentAmount ? parseFloat(paymentAmount).toLocaleString() : '0';
    },
  },
  {
    Header: "Due",
    Footer: "",
    accessor: row => {
      const balanceValue = row.balance ?? row.dueBalance;
      if (balanceValue !== undefined && balanceValue !== null) {
        return parseFloat(balanceValue).toLocaleString();
      }
      const amount = parseFloat(row.paymentInit?.amount || row.initialAmount || 0);
      const paymentAmount = parseFloat((row.totalPayments ?? row.totalPaid) || 0);
      const due = amount - paymentAmount;
      return due ? due.toLocaleString() : '0';
    },
  },
];
